import React from "react";
import { Drawer, DrawerContent, useDisclosure } from "@heroui/react";
import ButtonMethodPayment from "../../components/ButtonMethodPayment";
import { ReactComponent as Close } from "../../assets/close.svg";
import { ReactComponent as UpdateIcon } from "../../assets/update.svg";
import FormCreditCard from "../../components/FormCreditCard";
import { useStore } from "../../lib/store";
import { isMobile } from "react-device-detect";
import { AmplitudeLog } from "../../lib/amplitude";

interface Props {
  dotMode?: boolean;
  error?: string;
}

const RegisterCard: React.FC<Props> = ({ dotMode, error }) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();

  const { credit_card } = useStore();
  const { user } = useStore();
  const { external_link } = useStore();

  return (
    <>
      {isOpen && <div className="fixed inset-0 bg-black/50 z-40" />}
      {dotMode === true ? (
        <div
          className="flex flex-row items-center gap-2 mt-[1rem]"
          onClick={() => {
            AmplitudeLog("Inicio_atualizar_cartao_pagamento", {
              user_id: user,
            })
            onOpen();
          }}
        >
          <UpdateIcon className="w-[1rem] h-[1rem]" />
          <p className="text-green-dark underline">Atualizar Cartão</p>
        </div>
      ) : !credit_card?.name ? (
        <ButtonMethodPayment
          onClick={() => {
            onOpen();
            AmplitudeLog("Inicio_cadastro_cartao_pagamento", {
              user_id: user,
            });
          }}
          icon="cadastrar_cartao"
          theme="lightgreen"
          wide
        >
          Cadastrar Cartão
        </ButtonMethodPayment>
      ) : (
        <ButtonMethodPayment
          onClick={() => {
            AmplitudeLog("Inicio_atualizar_cartao_pagamento", {
              user_id: user,
            });
            onOpen();
          }}
          icon="cadastrar_cartao"
          theme="white"
          wide
          flat
          error={error !== "" ? "Encontramos problemas com o cartão" : undefined}
        >
          Atualizar Cartão
        </ButtonMethodPayment>
      )}
      <Drawer
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        placement={"bottom"}
        hideCloseButton
      >
        <DrawerContent
          className={`
          w-full
          rounded-t-[0.75rem]
          ${!isMobile && "!h-[100dvh] !rounded-none !border-none"}
          !max-h-screen 
          bg-white-primary
          px-[2rem]
          flex items-center
        `}
        >
          {(onClose) => (
            <div
              className={`${external_link && !isMobile ? "w-[60%]" : "w-full"} ${window.location.hostname === "checkout.kinology.com.br" && "w-[60%]"}`}
            >
              <div className="w-[100%] flex justify-end">
                <button
                  onClick={onClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    marginTop: "1.5rem",
                  }}
                >
                  <Close className="w-[1rem] h-[1rem]" />
                </button>
              </div>
              <FormCreditCard onClose={onClose} name_button="Pagar fatura" />
            </div>
          )}
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default RegisterCard;
